(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      var success = document.querySelector('.contact-form__success');
      if (success) {
        success.style.display = 'flex';
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
